import { createSignal } from '@verclam/pulsar';

/** `null` when no archiving is pending confirmation; otherwise the id of the beneficiary to confirm. */
const beneficiaryToArchiveSignal = createSignal<number | null>(null);

export const openBeneficiaryToArchive = (beneficiaryId: number): void => {
	beneficiaryToArchiveSignal.value = beneficiaryId;
};

export const closeBeneficiaryToArchive = (): void => {
	beneficiaryToArchiveSignal.value = null;
};

export default beneficiaryToArchiveSignal;
